import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getOrganizationFunctions } from 'services/admin';

export const getFunctionTreeReactQueryKey = () => [REACT_QUERY_KEYS.functionTree];

export const useGetFunctionTreeQuery = () => useQuery(getFunctionTreeReactQueryKey(), getOrganizationFunctions);
